import { LoadingButton } from '@mui/lab';
import { Stack, Button, useMediaQuery, Theme } from '@mui/material';

interface DoubleButtonProps {
  onClickFirstButton: () => any;
  onClickSecondButton: () => any;
  titleFirstButton: string;
  titleSecondButton: string;
  loading?: boolean;
}

export const DoubleButton = ({
  onClickFirstButton,
  onClickSecondButton,
  titleFirstButton,
  titleSecondButton,
  loading = false,
}: DoubleButtonProps) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Stack direction="row" spacing={isMobile ? 1 : 3}>
      <Button
        disabled={loading}
        sx={{ color: 'white' }}
        color="inherit"
        size={isMobile ? 'small' : 'medium'}
        onClick={onClickFirstButton}
      >
        {titleFirstButton}
      </Button>
      <LoadingButton
        loading={loading}
        color="primary"
        variant="contained"
        size={isMobile ? 'small' : 'medium'}
        onClick={onClickSecondButton}
      >
        {titleSecondButton}
      </LoadingButton>
    </Stack>
  );
};
